// extracted by mini-css-extract-plugin
export var active = "language-switch-module--active--56ce6";
export var author = "language-switch-module--author--3abdd";
export var category = "language-switch-module--category--de0c9";
export var headline = "language-switch-module--headline--f7171";
export var headlinePost = "language-switch-module--headline-post--a6867";
export var languageSwitch = "language-switch-module--language-switch--c38f5";
export var languageSwitchItem = "language-switch-module--language-switch-item--1e893";
export var languageSwitchWrapper = "language-switch-module--language-switch-wrapper--d26dd";
export var modal = "language-switch-module--modal--7b6b1";
export var paragraph = "language-switch-module--paragraph--438a1";
export var popover = "language-switch-module--popover--43ea9";
export var value = "language-switch-module--value--d394a";